export function emptyCondition() {
  return {
    attribute: "",
    operator: "EQUALS",
    value: ""
  };
}

export function emptyResourceScope() {
  return {
    type: "",
    filters: []
  };
}

export function emptyPolicy() {
  return {
    policyName: "",
    policyDescription: "",

    version: 1,

    priority: 1,

    effect: "ALLOW",

    roles: [],

    actions: [],

    resourceScope: {
      resourceType: "SCHEMA",
      resourceName: "",
      classification: "PUBLIC",
      filters: []
    },

    conditions: [],

    effectiveFrom: new Date().toISOString(),

    effectiveTo: null
  };
}